<script>
    import { resetPasswordByHash } from '/public/services/users/users';
    export let user;
    export let hash;

    let password = {
        password: null,
        password_confirmation: null
    }

    let passwordMismatch = false;
    let successfulReset = false;

    function processPasswordReset(e) {
        e.preventDefault();

        passwordMismatch = false;

        if (password.password != password.password_confirmation) {
            passwordMismatch = true;
            return;
        }

        resetPasswordByHash(hash, password).then(res => {
            if (res.success) {
                successfulReset = true;
            }
        });
    }

    function resetMismatch() {
        passwordMismatch = false;
    }

</script>

<div class="card">
    <div class="card-header">
        Hi {user.first}, you can reset your password
    </div>
    <div class="card-body">
        {#if successfulReset === false}
            <form on:submit={processPasswordReset}>
                <p class="mb-3">
                    <span class="fas fa-info-circle"></span> Complete the form to reset your password
                </p>
                <div class="row mb-3">
                    <label class="col-sm-3 col-form-label" for="password-one">
                        Password
                    </label>
                    <div class="col-sm-9">
                        <input id="password-one" type="password" class="form-control" required bind:value={password.password} minlength="8" placeholder="Enter your new Password, Min 8 chars"/>
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-sm-3 col-form-label" for="password-two">
                        Confirmation
                    </label>
                    <div class="col-sm-9">
                        <input on:keypress={resetMismatch} id="password-two" type="password" class="form-control" required bind:value={password.password_confirmation} minlength="8" placeholder="Enter your new Password again"/>
                    </div>
                </div>
                {#if passwordMismatch === true}
                    <div class="alert alert-warning mb-3">
                        <span class="fas fa-exclamation-triangle"></span> Your passwords do not match!
                    </div>
                {/if}
                <div class="row">
                    <div class="col-sm-9 offset-sm-3">
                        <button type="submit" class="btn btn-primary">
                            <span class="fas fa-save"></span> Reset Password
                        </button>
                    </div>
                </div>
            </form>
        {:else}
            <div class="alert alert-info">
                <span class="fas fa-info-circle"></span> Your password has been successfully reset, you may now login:<br/>
                <div class="text-center mt-3 mb-3">
                    <a href="/login" class="btn btn-primary">
                        <span class="fas fa-sign-in-alt"></span> Login
                    </a>
                </div>
            </div>
        {/if}
    </div>
</div>
